export enum Controller {
  AdminBallTypes = 'admin-ball-types',
  AdminCustomerApi = 'admin-customer-api',
  AdminErrorTypes = 'admin-error-types',
  AdminHawkeyeShots = 'admin-hawkeye-shots',
  AdminMachines = 'admin-machines',
  AdminModels = 'admin-models',
  AdminMSBSShots = 'admin-msbs-shots',
  AdminPitchLists = 'admin-pitch-lists',
  AdminRapsodoShots = 'admin-rapsodo-shots',
  AdminTeams = 'admin-teams',
  AdminTrackmanShots = 'admin-trackman-shots',
  AdminUsers = 'admin-users',
  AdminVisionDetections = 'admin-vision-detections',
  Airtable = 'airtable',
  Auth = 'auth',
  CustomerApiV1 = 'customer/v1',
  Data = 'data',
  DataCollections = 'data-collections',
  DataV3 = 'data/v3',
  FeatureFlags = 'feature-flags',
  Hawkeye = 'hawkeye',
  Hitters = 'hitters',
  MachineBurnInTests = 'machine-burn-in-tests',
  MachineConfigBackups = 'machine-config-backups',
  MachineHealthChecks = 'machine-health-checks',
  MachineImages = 'machine-images',
  MachineLogFiles = 'machine-log-files',
  MachineNetworkLogs = 'machine-network-logs',
  Machines = 'machines',
  MachineServiceLogs = 'machine-service-logs',
  MachineTelemetryLogs = 'machine-telemetry-logs',
  Main = 'main',
  MlbStats = 'mlb-stats',
  MongoCrud = 'mongo-crud',
  OnDemand = 'on-demand',
  Pitches = 'pitches',
  PitchLists = 'pitch-lists',
  PlatformConsole = 'platform-console',
  PlayerAppV1 = 'player-app/v1',
  Players = 'players',
  Python = 'python',
  ServerErrors = 'server-errors',
  ServerLogs = 'server-logs',
  Sessions = 'sessions',
  Shot = 'shot',
  SlackBot = 'slack-bot',
  State = 'state',
  StereoVideos = 'stereo-videos',
  Streaming = 'streaming',
  Tailscale = 'tailscale',
  Terms = 'terms',
  Trackman = 'trackman',
  TrainedMachineStates = 'trained-machine-states',
  TrainingLogs = 'training-logs',
  UserModels = 'user-models',
  Videos = 'videos',
  VisionAnnotations = 'vision-annotations',
  VisionAssets = 'vision-assets',
  VisionCameraCalibrations = 'vision-camera-calibrations',
  VisionDetections = 'vision-detections',
  VisionFireLogs = 'vision-fire-logs',
}
